import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className="absolute inset-0 w-screen overflow-hidden pointer-events-none">
      {/* Desktop animations - hidden on mobile for performance */}
      <div className="hidden md:block">
        {/* Animated flowing threads with glow effect */}
        <div className="absolute inset-0 opacity-15">
          {/* Thread 1 - Purple */}
          <div className="absolute top-1/4 left-0 w-screen h-0.5 bg-gradient-to-r from-transparent via-purple-400 to-transparent animate-flow-1 shadow-lg shadow-purple-400/50"></div>
          
          {/* Thread 2 - Blue */}
          <div className="absolute top-1/3 left-0 w-screen h-0.5 bg-gradient-to-r from-transparent via-blue-400 to-transparent animate-flow-2 shadow-lg shadow-blue-400/50"></div>
          
          {/* Thread 3 - Cyan */}
          <div className="absolute top-1/2 left-0 w-screen h-0.5 bg-gradient-to-r from-transparent via-cyan-400 to-transparent animate-flow-3 shadow-lg shadow-cyan-400/50"></div>
          
          {/* Thread 4 - Purple */}
          <div className="absolute top-2/3 left-0 w-screen h-0.5 bg-gradient-to-r from-transparent via-purple-400 to-transparent animate-flow-4 shadow-lg shadow-purple-400/50"></div>
          
          {/* Thread 5 - Blue */}
          <div className="absolute top-3/4 left-0 w-screen h-0.5 bg-gradient-to-r from-transparent via-blue-400 to-transparent animate-flow-5 shadow-lg shadow-blue-400/50"></div>
          
          {/* Thread 6 - Purple (additional) */}
          <div className="absolute top-1/5 left-0 w-screen h-0.5 bg-gradient-to-r from-transparent via-purple-300 to-transparent animate-flow-2 shadow-lg shadow-purple-400/30"></div>
          
          {/* Thread 7 - Cyan (additional) */}
          <div className="absolute top-4/5 left-0 w-screen h-0.5 bg-gradient-to-r from-transparent via-cyan-300 to-transparent animate-flow-4 shadow-lg shadow-cyan-400/30"></div>
        </div>
        
        {/* Additional wavy threads */}
        <div className="absolute inset-0 opacity-10">
          {/* Wavy thread 1 */}
          <div className="absolute top-1/6 left-0 w-screen h-0.5 bg-gradient-to-r from-transparent via-purple-300 to-transparent animate-flow-1" style={{ transform: 'translateY(10px)' }}></div>
          
          {/* Wavy thread 2 */}
          <div className="absolute top-5/6 left-0 w-screen h-0.5 bg-gradient-to-r from-transparent via-blue-300 to-transparent animate-flow-3" style={{ transform: 'translateY(-10px)' }}></div>
        </div>
        
        {/* Floating particles with glow */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-1/4 left-1/4 w-1.5 h-1.5 bg-purple-400 rounded-full animate-float-1 shadow-lg shadow-purple-400/50"></div>
          <div className="absolute top-1/3 right-1/3 w-1.5 h-1.5 bg-blue-400 rounded-full animate-float-2 shadow-lg shadow-blue-400/50"></div>
          <div className="absolute top-1/2 left-1/2 w-1.5 h-1.5 bg-cyan-400 rounded-full animate-float-3 shadow-lg shadow-cyan-400/50"></div>
          <div className="absolute top-2/3 right-1/4 w-1.5 h-1.5 bg-purple-400 rounded-full animate-float-4 shadow-lg shadow-purple-400/50"></div>
          <div className="absolute top-3/4 left-1/3 w-1.5 h-1.5 bg-blue-400 rounded-full animate-float-5 shadow-lg shadow-blue-400/50"></div>
        </div>
        
        {/* Glowing orbs with enhanced effects */}
        <div className="absolute inset-0 opacity-15">
          <div className="absolute top-1/4 right-1/4 w-3 h-3 bg-purple-400/40 rounded-full blur-sm animate-pulse shadow-lg shadow-purple-400/30"></div>
          <div className="absolute top-1/2 left-1/4 w-3 h-3 bg-blue-400/40 rounded-full blur-sm animate-pulse shadow-lg shadow-blue-400/30" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-3/4 right-1/3 w-3 h-3 bg-cyan-400/40 rounded-full blur-sm animate-pulse shadow-lg shadow-cyan-400/30" style={{ animationDelay: '2s' }}></div>
        </div>
        
        {/* Subtle background gradient overlay */}
        <div className="absolute inset-0 w-screen bg-gradient-to-br from-purple-900/5 via-transparent to-blue-900/5"></div>
      </div>
      
      {/* Mobile-friendly simplified animation */}
      <div className="md:hidden">
        {/* Simple gradient overlay for mobile */}
        <div className="absolute inset-0 w-screen bg-gradient-to-br from-purple-900/10 via-transparent to-blue-900/10"></div>
        
        {/* Minimal floating particles for mobile */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-1/4 left-1/4 w-1 h-1 bg-purple-400 rounded-full animate-pulse"></div>
          <div className="absolute top-1/2 right-1/4 w-1 h-1 bg-blue-400 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-3/4 left-1/3 w-1 h-1 bg-cyan-400 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>
      </div>
    </div>
  );
};

export default AnimatedBackground; 